import apiMeterClient from './apiMeterClient'

const changeToken = (token) => 
    apiMeterClient.defaults.headers['auth-api'] = token

const Client = { changeToken }

export default Client